import { z } from "zod";

const environmentSchema = z.object({
  VITE_API_BASE_URL: z.url(),
  VITE_COGNITO_CLIENT_ID: z.string().trim().min(1),
  VITE_COGNITO_DOMAIN: z.url(),
  VITE_COGNITO_LOGOUT_URI: z.url(),
  VITE_COGNITO_REDIRECT_URI: z.url(),
  VITE_ENVIRONMENT: z.enum(["development", "staging", "production", "test"]),
  VITE_ENABLE_LIVE_TRADING: z
    .enum(["true", "false"])
    .default("false")
    .transform((value) => value === "true"),
  VITE_RELEASE: z.string().trim().min(1).default("local"),
});

export type AppEnvironment = z.infer<typeof environmentSchema>;

export function parseEnvironment(input: Readonly<Record<string, unknown>>): AppEnvironment {
  return environmentSchema.parse(input);
}
